/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconDashboard extends React.Component {
  render() {
    const iconClasses = classNames("icon dashboard", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M27.879,15.203c-0.78-5.815-5.536-10.459-11.366-11.117C8.656,3.199,2,9.322,2,17c0,3.133,1.112,6.005,2.959,8.249 C5.346,25.719,5.918,26,6.527,26h16.956c0.569,0,1.125-0.229,1.49-0.665C27.213,22.659,28.398,19.069,27.879,15.203z M19.134,7.84 c0.276-0.478,0.888-0.642,1.366-0.366c0.478,0.276,0.642,0.888,0.366,1.366S19.978,9.482,19.5,9.206S18.858,8.318,19.134,7.84z M15,6c0.552,0,1,0.448,1,1c0,0.552-0.448,1-1,1s-1-0.448-1-1C14,6.448,14.448,6,15,6z M4,17c0-0.552,0.448-1,1-1s1,0.448,1,1 c0,0.552-0.448,1-1,1S4,17.552,4,17z M6.84,22.866c-0.478,0.276-1.09,0.112-1.366-0.366c-0.276-0.478-0.112-1.09,0.366-1.366 c0.478-0.276,1.09-0.112,1.366,0.366C7.482,21.978,7.318,22.59,6.84,22.866z M7.206,12.5c-0.276,0.478-0.888,0.642-1.366,0.366 C5.361,12.59,5.198,11.978,5.474,11.5c0.276-0.478,0.888-0.642,1.366-0.366C7.318,11.41,7.482,12.022,7.206,12.5z M10.5,9.206 C10.022,9.482,9.41,9.318,9.134,8.84S9.022,7.75,9.5,7.474c0.478-0.276,1.09-0.112,1.366,0.366S10.978,8.93,10.5,9.206z M13.268,18 c-0.552-0.957-0.225-2.18,0.732-2.732c0.601-0.347,5.194-2.087,8.525-3.332c0.668-0.25,1.174,0.626,0.623,1.08 c-2.744,2.262-6.547,5.37-7.148,5.717C15.043,19.284,13.82,18.957,13.268,18z M24.526,22.5c-0.276,0.478-0.888,0.642-1.366,0.366 c-0.478-0.276-0.642-0.888-0.366-1.366c0.276-0.478,0.888-0.642,1.366-0.366C24.639,21.41,24.802,22.022,24.526,22.5z M25,18 c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C26,17.552,25.552,18,25,18z" />
      </svg>
    );
  }
}

IconDashboard.defaultProps = {
  className: null
};

IconDashboard.propTypes = {
  className: PropTypes.string
};

export default IconDashboard;
